import { environment } from '../environments/environment';
import { ApiEndpoint } from '../types/api';

export const API_ENDPOINT_NAMES = {
  [ApiEndpoint.gnpKmSeguros]: environment.awsAPIEndpointName,
  [ApiEndpoint.core]: environment.awsAPICoreEndpointName,
  [ApiEndpoint.monitoring]: environment.awsAPIMonitoringEndpointName,
};
